
<p *ngFor="let item of items" 
    [innerHTML]="item.text"
    [ngClass]="item.customClass">
</p>